import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClickOutsideModule } from 'ng-click-outside';
import { UtilsModule } from '../utils/utils.module';
import { HeaderBarComponent } from './header-bar/header-bar.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { StayInTouchComponent } from './stay-in-touch/stay-in-touch.component';
import { SuperAdminSideMenuComponent } from './super-admin-side-menu/super-admin-side-menu.component';
import { ProfilePictureComponent } from './profile-picture/profile-picture.component';
import { KycVideoPlayerComponent } from './kyc-video-player/kyc-video-player.component';
import { PdfPreviewComponent } from './pdf-preview/pdf-preview.component';
import { WelcomeMsgToCorporateUserComponent } from './welcome-msg-to-corporate-user/welcome-msg-to-corporate-user.component';
import { WelcomeMsgToNonCorpUserComponent } from './welcome-msg-to-non-corp-user/welcome-msg-to-non-corp-user.component';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwictherComponent } from './language-swicther/language-swicther.component';
import { StepNavigationComponent } from './step-navigation/step-navigation.component';
import { StepContainerComponent } from './step-container/step-container.component';
import { IdleLogoutDirective } from './idle-logout.directive';
import { IdleCountdownComponent } from './idle-countdown/idle-countdown.component';
import { MfaConfigurationComponent } from './mfa-authenticator/mfa-configuration/mfa-configuration.component';
import { MfaAuthenticatorComponent } from './mfa-authenticator/mfa-authenticator.component';
import { SetPinComponent } from './set-pin/set-pin.component';
import { PinEnterScreenComponent } from './set-pin/pin-enter-screen.component';
import { OtpscreenComponent } from './set-pin/otpscreen.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { EnterNickNameComponent } from '../portal/profile/enter-nick-name/enter-nick-name.component';
import {
  RestrictedNamesDialogComponent
} from '../portal/profile/enter-nick-name/restricted-names-dialog/restricted-names-dialog.component';
import { PrimaryButtonComponent } from './primary-button/primary-button.component';
import { HelpBoxComponent } from './help-box/help-box.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UtilsModule,
    ClickOutsideModule,
    DropDownListModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [
    HeaderBarComponent,
    SideMenuComponent,

    StayInTouchComponent,
    SuperAdminSideMenuComponent,
    ProfilePictureComponent,
    KycVideoPlayerComponent,
    PdfPreviewComponent,
    VerifyEmailComponent,
    WelcomeMsgToCorporateUserComponent,
    WelcomeMsgToNonCorpUserComponent,
    LanguageSwictherComponent,
    StepNavigationComponent,
    StepContainerComponent,
    IdleLogoutDirective,
    IdleCountdownComponent,
    MfaAuthenticatorComponent,
    MfaConfigurationComponent,
    SetPinComponent,
    PinEnterScreenComponent,
    OtpscreenComponent,
    EnterNickNameComponent,
    RestrictedNamesDialogComponent,
    PrimaryButtonComponent,
    HelpBoxComponent,
  ],
  exports: [
    HeaderBarComponent,
    SideMenuComponent,
    SuperAdminSideMenuComponent,
    MfaConfigurationComponent,
    MfaAuthenticatorComponent,
    StayInTouchComponent,
    ProfilePictureComponent,
    PdfPreviewComponent,
    VerifyEmailComponent,
    LanguageSwictherComponent,
    StepNavigationComponent,
    StepContainerComponent,
    IdleLogoutDirective,
    IdleCountdownComponent,
    EnterNickNameComponent,
    RestrictedNamesDialogComponent,
    PrimaryButtonComponent,
    HelpBoxComponent,
    TranslateModule,
  ],
  providers: [],
})
export class SharedModule { }
